<div class="right-panel">
  <div class="panel-header">
    <p class="panel-title"> Create a Roaming Community</p>
  </div>
  <div class="panel-container">
    <form name="createRC"
          class="createNS"
          #validate="ngForm"
          action="">

      <div class="createNS-row">
        <label for="name" class="widget-create-title">Name
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="name"
               class="widget-create-content form-control"
               [ngClass]="{'nameUsedError': nameExist}"
               [(ngModel)]="roamingCommunityModel.name"
               name="name"
               required
               #nameInput
               maxlength="40"
               #name="ngModel"
               (input)="validateName(roamingCommunityModel.name, nameInput)"
               (keyup)="trimValue($event)"
               autocomplete="off"/>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="name.invalid && (name.dirty || name.touched)"
             class="alert alert-danger alert-validate">
          <div [hidden]="!name.hasError('required')">Name is required</div>
        </div>
        <div *ngIf="nameExist"
             class="alert alert-danger alert-validate">Name already exist!
        </div>
      </div>

      <!--  ProtocolVersion field-->
      <div class="createNS-row">
        <label class="widget-create-title">Protocol Version
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [items]="protocolVersions"
                     (select)="selectedProtocolVersion($event)">
          </ngx-select>
        </div>
      </div>

      <div class="btn-area">
        <button type="button" class="custom-btn"
                (click)="backClicked()">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [disabled]="disableName
                || hasError
                || nameExist
                || duplicatesExist
                || noValid
                || !protocolVersionExists
                || disableSaveButton
                "
                (click)="saveRoamingCommunity()">Save
        </button>
      </div>
    </form>
  </div>
</div>
